import {
	ICommonAppData,
	TLocalAppDataGetter,
} from '../../../Common/services/app_data/local_app_data.token';

export const authenticationMeetingsLocalAppDataGetter: TLocalAppDataGetter = (
	locale: string,
	location: Location,
): ICommonAppData => ({
		locale,
		appName: 'Bankro.tech',
		appFullLocationUrl: `${ location.protocol }//${ location.host }${ location.pathname.toLowerCase().replace(/\/admin(\/)?$/g, '/') }`,
		authenticationReturnUrl: `${ location.origin || '/' }${ location.hash }`,
		appStartNotificationText: '', // For test notifications 'Access denied' before redirect
		domainName: location.host,
		registrationErrorTitle: '', // If registration by link is disabled - this field used as title for block of blocking reason
		registrationErrorText: '', // If registration by link is disabled - this field used as description for block of blocking reason
		isRegistrationByLinkEnabled: true, // Flag indicating is registration by link are enabled in service
		authFlashMessage: false, // Field used to show user some notification under login block
		colorsDictionarySysName: null,
	});
